var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require('@/assets/images/spinner.svg')}}),_c('p',{staticStyle:{"color":"rgb(251, 177, 205)","font-weight":"bold","font-size":"18px"}},[_vm._v("Merci de patienter, vous allez être redirigé.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }